define('drops/calendarWeekView/calendarWeekView',[
    'jquery',
    'underscore',
    'globalize',
    'luxon',
    'lq/constants',
    'lq/drop',
    'drops/calendar/calendarParameter',
    'drops/calendar/calendarItems',
    'lq/windowSize',
    'lq/nestingContext',
    'lq/multiSourceValue',
    'tpl!drops/calendarWeekView/calendarWeekView.html',
    'lq/onlongpress'
], function ($, _, globalize, luxon, constants, Drop, calendarParameter, calendarItems, windowSize, NestingContext, multiSourceValue, template, OnLongPress) {
    'use strict';

    const { DateTime, Interval } = luxon;

    var defaults = {
        data: {
            dataSource: null,
            dataSourceType: 'datetimes',
            dateOutput: null,
            startOutput: null,
            endOutput: null,
            calendarStartParameter: 'CalendarWeekStart',
            calendarEndParameter: 'CalendarWeekEnd',
            timeslotSize: 30,
            dayStart: 0,
            dayEnd: (60 * 24) - 1,
            titleFormat: 'D',
            dayHeaderFormat: 'ddd, MMM dd',
            timeslotHourFormat: 'HH:mm',
            hideTitleEndDate: false
        },
        childDrops: [
            {
                data: { type: 'CalendarItem' }
            }
        ]
    };

    function CalendarWeekView(options) {
        Drop.call(this, $(template()), defaults, options);
        // right now we're not really doing anything with the selected date in the week view
        this.selectedDate = null;
    };

    Drop.extend(CalendarWeekView, Drop);

    CalendarWeekView.typeName = 'CalendarWeekView';

    CalendarWeekView.prototype.applyPosition = $.noop;

    CalendarWeekView.prototype.loadCalendarData = function () {
        if (!this.data.dataSource)
            return;

        var dateOfRequestedData = this.date;

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (response) {
                if (dateOfRequestedData.equals(self.date))
                    self.showItems(response.outputs, response.results);
            });

        if (!this.data.activeTSDataSource)
            return;

        this.piping.queryDispatcher.backgroundDispatch(
            this.data.activeTSDataSource,
            function (response) {
                if (dateOfRequestedData.equals(self.date))
                    self.setActiveTimeslots(response.results);
            });
    };

    CalendarWeekView.prototype.setSelectedDate = function (date) {
        this.selectedDate = date;
    };

    CalendarWeekView.prototype.clearSelectedDate = function () {
        this.selectedDate = null;
    };

    CalendarWeekView.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    CalendarWeekView.prototype.init = function () {
        this.nestingContext = new NestingContext(this.piping);

        multiSourceValue.initialize(
            this,
            this.data.scrollPosition,
            this.goToScrollToPosition.bind(this));
    };

    CalendarWeekView.prototype.goToScrollToPosition = function (scrollPosition) {
        if (this.isValidISOFormat(scrollPosition)) {
            scrollPosition = this.getMinutesFromMidnight(scrollPosition);
        }

        if (!$.isNumeric(scrollPosition)) {
            return;
        }
        
        var slotNumber = Math.floor((scrollPosition - this.data.dayStart) / this.data.timeslotSize);
        var $slot = this.$hours.children('.timeslot').eq(slotNumber);
        this.$container.scrollTop(this.$container.scrollTop() + $slot.position().top);
    };

    CalendarWeekView.prototype.getMinutesFromMidnight = function (dateString) {
        var date = new Date(dateString);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var totalMinutes = hours * 60 + minutes;

        return totalMinutes;
    };

    CalendarWeekView.prototype.isValidISOFormat = function (input) {
        if (typeof input !== "string") {
            return false;
        }
        return DateTime.fromISO(input).isValid;
    };

    CalendarWeekView.prototype.render = function () {
        this.registerForDataSource();
        this.prepareUi();
        this.createWeekdayHeaders();
        this.createWeekdayColumns();
        this.createTimeslots();
        this.open(DateTime.now());

        var self = this;
        _.each(this.$columns, function ($weekday, dayOfWeek) {
            if ($(self.$headers[dayOfWeek]).hasClass('today')) {
                $weekday.children().addClass('today');
            }
        });
    };

    CalendarWeekView.prototype.prepareUi = function () {
        this.$container = this.$element.find('.calendar-main');
        this.$title = this.$element.find('.date-as-title');
        this.$hours = this.$element.find('.hours');
        this.$weekdays = this.$element.find('.weekdays');
        this.$weekdayHeaders = this.$element.find('.weekday-headers');

        this.$backPage = this.$element.find('.previous-page');
        this.$nextPage = this.$element.find('.next-page');

        var self = this;
        this.$backPage
            .on('click', function () {
                self.previous();
            });
        this.$nextPage
            .on('click', function () {
                self.next();
            });

        this.events(windowSize,
            {
                'Changed': this.updateHeadersWidth.bind(this)
            });
    };

    CalendarWeekView.prototype.afterShown = function () {
        this.updateHeadersWidth();
        this.updateHeadersLeftMargin();
    };

    CalendarWeekView.prototype.createWeekdayHeaders = function () {
        this.$headers = _.map(_.range(0, 7), function () {
            return $('<div />')
                .addClass('weekday-header');
        });
        this.$weekdayHeaders.append(this.$headers);
    };

    CalendarWeekView.prototype.createWeekdayColumns = function () {
        this.$columns = _.map(_.range(0, 7), function () {
            return $('<div />')
                .addClass('weekday')
                .append(
                    $('<div class="calendar-item-container"/>')
                );
        });
        this.$weekdays.append(this.$columns);
    };

    CalendarWeekView.prototype.createTimeslots = function () {
        var timeslots = _.range(this.data.dayStart, this.data.dayEnd, this.data.timeslotSize);

        var self = this;
        _.each(this.$columns, function ($weekday, dayOfWeek) {
            var $timeslots = _.map(timeslots, function (startMinute) {
                var $slot = $('<div />')
                    .addClass('timeslot')
                    .data('dayOfWeek', dayOfWeek)
                    .data('time', startMinute);

                new OnLongPress().applyLongPressOnElement($slot, self,
                    function(e) {
                        return self.determineEventArg(dayOfWeek, startMinute);
                    }, function() {
                        self.timeslotClicked(dayOfWeek, startMinute);
                    });

                $slot.on("mousedown", calendarItems.timeslotMousedown.bind(self, $weekday, dayOfWeek));
                $slot.on("mouseup", calendarItems.timeslotMouseup.bind(self));
                $slot.on("mousemove", calendarItems.timeslotMousemove.bind(self));

                return $slot;
            });
            $weekday.append($timeslots);
        });

        var $hours = _.map(timeslots, function (timeslot) {
            var date = new Date(1970, 0, 1);
            date.setMinutes(timeslot);

            return $('<div />')
                .addClass('timeslot')
                .text(globalize.format(date, self.data.timeslotHourFormat));
        });
        this.$hours
            .append($('<div class="calendar-header"></div>'))
            .append($hours);
    };

    CalendarWeekView.prototype.determineEventArg = function (dayOfWeek, startMinute) {
        var dateAndTime = this.monday
            .plus({ days: dayOfWeek })
            .plus({ minutes: startMinute });
        return globalize.format(dateAndTime.toJSDate(), constants.licquidDateFormat);
    };

    CalendarWeekView.prototype.timeslotClicked = function (dayOfWeek, startMinute) {
        var eventArg = this.determineEventArg(dayOfWeek, startMinute);
        this.triggerEvent(this.data.eventing.clicked.raisedEventName, eventArg);
    };

    CalendarWeekView.prototype.registerForDataSource = function () {
        if (this.data.dataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data, _isUpdate) {
                self.removeCalendarItems();
                self.showItems(data.outputs, data.results);
            });
        }

        if (this.data.activeTSDataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.activeTSDataSource, function (data, _isUpdate) {
                self.setActiveTimeslots(data.results);
            });
        }
    };

    CalendarWeekView.prototype.previous = function () {
        this.open(this.date.minus({ weeks: 1}));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarWeekView.prototype.next = function () {
        this.open(this.date.plus({ weeks: 1}));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarWeekView.prototype.triggerNavigatedEvent = function () {
        this.triggerEventIfEnabled('navigated', this.getStartOfCurrentWeek());
    };

    CalendarWeekView.prototype.open = function (date) {
        this.date = date;

        this.monday = this.date.startOf('week');
        this.sunday = this.date.endOf('week');

        this.updateTitle();
        this.updateWeekdayHeaders();
        this.removeCalendarItems();
        this.updateHeadersWidth();
        this.updateHeadersLeftMargin();

        var parameters = this.piping.parameters;
        parameters.locals.setValue(this.data.calendarStartParameter, calendarParameter.convert(this.getStartOfCurrentWeek()));
        parameters.locals.setValue(this.data.calendarEndParameter, calendarParameter.convert(this.getEndOfCurrentWeek()));
    };

    CalendarWeekView.prototype.getStartOfCurrentWeek = function() {
        return this.getOpenDate().startOf('week');
    };

    CalendarWeekView.prototype.getEndOfCurrentWeek = function() {
        return this.getOpenDate().endOf('week');
    };

    CalendarWeekView.prototype.updateTitle = function () {
        if (!this.data.hideTitleEndDate) {
            var title = globalize.format(this.monday.toJSDate(), this.data.titleFormat) + ' - ' + globalize.format(this.sunday.toJSDate(), this.data.titleFormat);
        } else {
            var title = globalize.format(this.monday.toJSDate(), this.data.titleFormat);
        }
        this.$title.text(title);
    };

    CalendarWeekView.prototype.updateWeekdayHeaders = function() {
        var self = this;
        _.each(this.$headers, function ($header, i) {
            var date = self.monday.plus({ days: i });
            var weekDayTitle = globalize.format(date.toJSDate(), self.data.dayHeaderFormat);
            $header.text(weekDayTitle);
            var today = DateTime.now();
            if (date.hasSame(today, 'day')) {
                $header.addClass('today');
            }
        });
    };

    CalendarWeekView.prototype.updateHeadersWidth = function () {
        // WHY give the cells in the header row the same width as the weekday columns
        // this handles the appearance/dissapearance of a scrollbar
        var self = this;
        _.defer(function () {
            self.$weekdayHeaders.width(self.$weekdays.width());
        });
    };

    CalendarWeekView.prototype.updateHeadersLeftMargin = function () {
        // WHY mergin on the left should be equal to the width of the column that contains the hours
        var self = this;
        _.defer(function() {
            self.$weekdayHeaders.css('margin-left', self.$hours.outerWidth());
        });
    };

    CalendarWeekView.prototype.getOpenDate = function () {
        return this.date;
    };

    CalendarWeekView.prototype.showItems = function (outputs, rows) {
        var self = this;

        var startOfCurrentWeek = this.getStartOfCurrentWeek();
        var endOfCurrentWeek = this.getEndOfCurrentWeek();

        var items = _.chain(rows)
            .map(function(row) {
                var startOfItem = self.getDatetimeFromRow(row, self.data.startOutput);
                var endOfItem = self.getDatetimeFromRow(row, self.data.endOutput);
                var currentWeekInterval = Interval.fromDateTimes(startOfCurrentWeek, endOfCurrentWeek);

                var startIsBetween = currentWeekInterval.contains(startOfItem);
                var endIsBetween = currentWeekInterval.contains(endOfItem);

                var diff = 0;
                if (!startIsBetween || !endIsBetween) { // Multiweek case
                    diff = Math.ceil(endOfItem.endOf('day').diff(startOfItem.startOf('day'), 'days').days);
                } else {
                    diff = endOfItem.weekday - startOfItem.weekday + 1;
                }

                return _.chain(_.range(diff))
                    .map(function (dayDifference) {
                        return startOfItem.plus({ days: dayDifference });
                    })
                    .filter(function (dateTime) {
                        return (startOfCurrentWeek <= dateTime)
                            && (dateTime <= endOfCurrentWeek)
                            && (!dateTime.startOf('day').equals(endOfItem));
                    })
                    .map(function(dateTime) {
                        var startOfItemInCurrentDay = dateTime.hasSame(startOfItem, 'day') ?
                            dateTime : dateTime.startOf('day');
                        var endOfItemInCurrentDay = dateTime.hasSame(endOfItem, 'day') ?
                            endOfItem : dateTime.endOf('day');

                        var weekday = startOfItemInCurrentDay.weekday - 1;
                        var $weekday = self.$columns[weekday].find('.calendar-item-container');

                        return $.extend(true, {}, self.childDrops[0], {
                            data: {
                                $target: $weekday,
                                startOfDay: startOfItemInCurrentDay.startOf('day').plus({ minutes: self.data.dayStart }),
                                endOfDay: endOfItemInCurrentDay.startOf('day').plus({ minutes: self.data.dayEnd }),
                                startOfItem: startOfItemInCurrentDay,
                                endOfItem: endOfItemInCurrentDay,
                                row: row,
                                outputs: outputs,
                                eventArg: self.data.eventArg,
                                tooltipOutput: self.data.tooltipOutput,
                                idOutput: self.data.idOutput
                            }
                        });
                    })
                    .value();
            })
            .flatten()
            .value();

        calendarItems.fillUp(this, items)
            .then(function () {
                self.nestingContext.executeDataSources();
            }).catch(function (e) {
                self.piping.errorHandler.showErrorDialog(e);
            });
    };

    CalendarWeekView.prototype.removeCalendarItems = function () {
        _.each(this.pool, function (drop) {
            drop.$element.remove();
        });
        this.removeAllDrops();
        this.data.calendarItemGroups = [];
    };

    CalendarWeekView.prototype.getDatetimeFromRow = function (row, output) {
        if (this.data.dataSourceType === 'datetimes')
            return DateTime.fromISO(row[output]);

        var dateTime = DateTime.fromISO(row[this.data.dateOutput]).startOf('day');
        var time = row[output];
        return dateTime.plus({ seconds: time });
    };

    CalendarWeekView.prototype.setActiveTimeslots = function (rows) {
        var self = this;

        var $timeslots = self.$weekdays.find('.timeslot');
        var $activeTimeslots = $();

        rows.forEach(function (row) {
            var activeTSStart = self.getDatetimeFromRow(row, self.data.activeTSStartOutput).toJSDate();
            var activeTSEnd = self.getDatetimeFromRow(row, self.data.activeTSEndOutput).toJSDate();

            var $filteredTimeslots = $timeslots.filter(function () {
                var dayOfWeek = $(this).data('dayOfWeek');
                var time = $(this).data('time');

                return dayOfWeek + 1 === activeTSStart.getDay()
                    && time >= self.getTimeOfDay(activeTSStart)
                    && time < self.getTimeOfDay(activeTSEnd);
            });

            $activeTimeslots.push(...$filteredTimeslots);
        });

        $activeTimeslots.addClass('active-timeslot');
        $timeslots.not($activeTimeslots).removeClass('active-timeslot');
    };

    CalendarWeekView.prototype.getTimeOfDay = function (date) {
        return date.getHours() * 60 + date.getMinutes();
    };

    return CalendarWeekView;
});

